var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePrimary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.38636 5.74993L10.2802 9.64392C10.5336 9.89721 10.5336 10.3067 10.2802 10.56C10.0269 10.8133 9.61736 10.8133 9.36407 10.56L5.47016 6.66604L1.57636 10.56C1.32295 10.8133 0.913549 10.8133 0.660266 10.56C0.406864 10.3067 0.406864 9.89721 0.660266 9.64392L4.55407 5.74993L0.660266 1.85593C0.406864 1.60264 0.406864 1.19311 0.660266 0.939818C0.786493 0.813471 0.952461 0.75 1.11831 0.75C1.28416 0.75 1.45001 0.813471 1.57636 0.939818L5.47016 4.83382L9.36407 0.939818C9.49042 0.813471 9.65627 0.75 9.82212 0.75C9.98797 0.75 10.1538 0.813471 10.2802 0.939818C10.5336 1.19311 10.5336 1.60264 10.2802 1.85593L6.38636 5.74993Z",
    fill: "#116E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimary);
export default __webpack_public_path__ + "static/media/closePrimary.69e852c92a6099500a311eaecddc7845.svg";
export { ForwardRef as ReactComponent };